export const title = 'Checkout Manager'
export const baseURL = '/manager'



// WEBPACK FOOTER //
// ./utils/project.js